import React, { useReducer } from 'react';

import { node } from 'prop-types';

import JobContext from './JobContext';

export default function JobProvider({ children }) {
  const jobReducer = (state, action) => ({
    ...state,
    ...(typeof action === 'function' ? action(state) : action)
  });

  const [jobState, setJobState] = useReducer(jobReducer, {
    currentJob: {},
    currentStep: {},
    isLoadingJob: false,
    isJobEditorOpen: false,
    isJobEditorMaximized: false,
    contextMenuProps: {
      left: 0,
      top: 0,
      // when supporting multiple next and prev, refactor this.
      prevStepId: null,
      nextStepId: null
    },
    isContextMenuOpen: false
  });

  return (
    <JobContext.Provider value={[jobState, setJobState]}>
      {children}
    </JobContext.Provider>
  );
}

JobProvider.propTypes = {
  children: node.isRequired
};
